import React, { useState, useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { authAPI } from '@/service/admin';
import './index.scss';

const Login: React.FC = () => {
  const navigate = useNavigate();
  const [phone, setPhone] = useState('');
  const [code, setCode] = useState('');
  const [loading, setLoading] = useState(false);
  const [codeLoading, setCodeLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [countdown, setCountdown] = useState(0);

  const handleSendCode = async () => {
    if (!/^1\d{10}$/.test(phone)) {
      setError('请输入正确的手机号');
      return;
    }

    setCodeLoading(true);
    setError(null);
    try {
      await authAPI.sendCode(phone);
      setCountdown(60);
      const timer = setInterval(() => {
        setCountdown((prev) => {
          if (prev <= 1) {
            clearInterval(timer);
            return 0;
          }
          return prev - 1;
        });
      }, 1000);
    } catch {
      setError('验证码发送失败，请稍后重试');
    } finally {
      setCodeLoading(false);
    }
  };

  const handleLogin = async () => {
    if (!phone || !code) {
      setError('请填写手机号和验证码');
      return;
    }

    setLoading(true);
    setError(null);
    try {
      const res = await authAPI.login(phone, code);
      if (res.success && res.data?.token) {
        localStorage.setItem('token', res.data.token);
        navigate('/admin/write');
      } else {
        setError(res.message || '登录失败');
      }
    } catch {
      setError('登录失败，请检查验证码是否正确');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (token) {
      navigate('/admin/write');
    }
  }, []);

  return (
    <div className="login-container">
      <div className="login-card">
        <h1 className="login-title">管理员登录</h1>
        <p className="login-subtitle">手机号 + 短信验证码登录</p>

        {error && <div className="login-error">{error}</div>}

        <div className="form-group">
          <label className="form-label">手机号</label>
          <input
            className="form-input"
            type="tel"
            placeholder="请输入手机号"
            value={phone}
            onChange={(e) => setPhone(e.target.value)}
            maxLength={11}
          />
        </div>

        <div className="form-group">
          <label className="form-label">验证码</label>
          <div className="phone-row">
            <input
              className="form-input"
              type="text"
              placeholder="请输入验证码"
              value={code}
              onChange={(e) => setCode(e.target.value)}
              maxLength={6}
            />
            <button
              className="send-code-btn"
              style={{ height: '44px' }}
              onClick={handleSendCode}
              disabled={codeLoading || countdown > 0}
            >
              {countdown > 0 ? `${countdown}s` : '获取验证码'}
            </button>
          </div>
        </div>

        <button
          className="login-btn"
          onClick={handleLogin}
          disabled={loading}
        >
          {loading ? '登录中...' : '登录'}
        </button>

        <Link to="/" className="login-back">← 返回首页</Link>
      </div>
    </div>
  );
};

export default Login;
